import { BLOCK_CLASSES as e } from "../../constants.js";
const r = {
  inline: !1,
  attrs: {
    type: { default: "placeholder" }
  },
  group: "block",
  atom: !0,
  allowGapCursor: !1,
  parseDOM: [],
  toDOM() {
    return [
      "div",
      {
        class: `${e.placeholder}`
      }
    ];
  }
};
export {
  r as placeholderSpec
};
